import * as React from "react";

export const CheckmarkIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="14.5" height="9.5" viewBox="0 0 16 12" fill="none" {...props}>
    <path d="M0.5 5.5L5.5 10.5L15 1" stroke="currentColor" strokeWidth="1.2" />
  </svg>
);
